import ToolDetailsProvider from './ToolDetailsContext';
import ToolDetails from './ToolDetails';

let Index = () => {
    return (
        <ToolDetailsProvider>
            <ToolDetails />
        </ToolDetailsProvider>
    )
}

export default Index;